<div class="batch-tree">
    <app-batch-node [model]='rootModel'></app-batch-node>
</div>